// @flow

import * as React from 'react';
import { Button } from 'antd';
import { MailOutlined } from '@ant-design/icons';

type Props = {
  project: {},
  onClickRequestFeedback: Function,
}

export default class extends React.PureComponent<Props> {

  render () {
    
    const {
      project,
      onClickRequestFeedback,
    } = this.props;

    const canRequestFeedback = project.phase_key === 3 && !project.hasPendingFeedback && !project.hasCompletedFeedback;

    return (
      <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Client Feedback</h2>
        <Button
          type="primary"
          icon={<MailOutlined />}
          onClick={onClickRequestFeedback}
          disabled={!canRequestFeedback}
        >
          Request Feedback
        </Button>
      </div>
    )
  }
}
